import type { UseBaseQueryOptions } from '@tanstack/react-query'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useQuery from 'src/hooks/utils/useQuery'

export interface Emission {
  subscriptionId?: string
  resourceType?: string
  location?: string
  scope1?: number
  scope2?: number
  scope3?: number
  date?: string // Date only string
}

export interface EmissionsQueryInput {
  subscriptionIds: string[]
  months?: number
}

const useEmissionsQuery = (input: EmissionsQueryInput, options?: UseBaseQueryOptions<Emission[]>) => {
  const account = useAccount()

  const emissionsQueryResult = useQuery(
    ['useEmissionsQuery', account.id, input],
    async ({ signal }) => {
      const response = await api.post(`/sustainability/account/${account.id}/emissions`, input, {
        signal
      })

      return response.data
    },
    {
      enabled: input.subscriptionIds.length > 0 && !!account.id,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      ...options
    }
  )

  return {
    ...emissionsQueryResult,
    data: emissionsQueryResult.data?.map((emission) => ({
      ...emission,
      scope1: emission.scope1 ?? 0,
      scope2: emission.scope2 ?? 0,
      scope3: emission.scope3 ?? 0
    }))
  }
}

export default useEmissionsQuery
